<template lang="pug">
#central-alertas(v-loading='carregando', style='height: 100%')
    h3 {{ $t('mensagens.home.centralAlertas.titulo') }}
    .lyra__cartao
        el-tabs.central-alertas__space(v-model='active', stretch)
            el-tab-pane(
                v-for='total in totalizadores',
                :key='total.name',
                :label='total.nome',
                :name='total.periodo'
            )
                .central-alertas__master
                    .central-alertas__lado
                        span.central-alertas__numero
                            | {{ total.socioambiental }}
                        .central-alertas__tipo
                            p {{ $t('mensagens.home.centralAlertas.alertas') }}
                            p {{ $t('mensagens.home.centralAlertas.socioambientais') }}
                    .central-alertas__lado
                        span.central-alertas__numero
                            | {{ total.agricola }}
                        .central-alertas__tipo
                            p {{ $t('mensagens.home.centralAlertas.alertas') }}
                            p {{ $t('mensagens.home.centralAlertas.agricolas') }}

        el-tooltip(v-if='erroAoBuscar', placement='left', content='Atualizar')
            .central-alertas__erro-carregamento
                i.el-icon-refresh-right(@click='buscarTotalizadores()')
</template>

<script>
import AlertaService from '@/services/AlertaService';

export default {
    name: 'CentralAlerta',

    mounted() {
        this.buscarTotalizadores();
    },

    data() {
        return {
            totalizadores: {},
            active: 'diario',
            carregando: true,
            erroAoBuscar: false
        };
    },

    methods: {
        async buscarTotalizadores() {
            this.carregando = true;
            await AlertaService.buscarTotalizadores()
                .then(({ data }) => {
                    this.totalizadores = data;
                    this.erroAoBuscar = false;
                })
                .catch(() => {
                    this.erroAoBuscar = true;
                    this.totalizadores = [
                        {
                            periodo: 'diario',
                            socioambiental: '--',
                            agricola: '--',
                            nome: this.$t('mensagens.blocoAlerta.filtros.hoje')
                        },
                        {
                            periodo: 'semanal',
                            socioambiental: '--',
                            agricola: '--',
                            nome: this.$t(
                                'mensagens.blocoAlerta.filtros.seteDias'
                            )
                        },
                        {
                            periodo: 'mensal',
                            socioambiental: '--',
                            agricola: '--',
                            nome: this.$t(
                                'mensagens.blocoAlerta.filtros.trintaDias'
                            )
                        }
                    ];
                    this.$notify.warning({
                        message: this.$t('mensagens.home.centralAlertas.erro')
                    });
                })
                .finally(() => {
                    this.carregando = false;
                });
        }
    },
    watch: {
        '$i18n._vm.locale': function () {
            this.buscarTotalizadores();
        }
    }
};
</script>

<style lang="scss" scoped>
.lyra__cartao {
    height: 100%;
}
.central-alertas__erro-carregamento {
    color: var(--primary);
    cursor: pointer;
    position: absolute;
    right: 18px;
    bottom: 10px;
}
.central-alertas__space {
    padding: 0 20px;
}
.central-alertas__lado {
    width: 50%;
    display: flex;
    flex-direction: row;
    align-items: center;
    min-height: 70px;
    justify-content: center;
}
.central-alertas__master {
    display: flex;
    justify-content: space-between;
    height: 100%;
    min-height: 120px;
}
.central-alertas__master:first-child {
    margin-left: 10px;
}
.central-alertas__numero {
    font-size: 45px;
    color: var(--warning);
    font-weight: 500;
    margin-right: 10px;
    word-break: break-all;
    line-height: 45px;
}
.central-alertas__tipo p {
    margin: 0;
}
</style>

<style lang="scss">
#central-alertas {
    position: relative;

    .el-tabs__item {
        color: var(--primary) !important;
    }
    .el-tabs__item.is-active {
        color: var(--primary) !important;
    }
    .el-tabs__active-bar {
        background-color: var(--secondary) !important;
    }
    .el-tabs__nav-wrap:after {
        background-color: var(--white) !important;
    }
    & > h3 {
        font-weight: 700;
        margin-bottom: 5px;
    }
}
</style>
